import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Popover,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import routes from "./basic/routes";

// import { TopBar } from "./basic/TopBar";
// import { AppDrawer } from "./basic/AppDrawer";
import { ContainerDrawer } from "./basic/container-drawer";
import { WeatherInfo } from "./components/OpenData";
import WeatherData from "./services/shared_weather";
import { AppSingleton } from "./services/user_config";
import { hkoCodeToImageName } from "./utils/CommonUtils";

const App = () => {
  // const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [icons, setIcons] = useState([]);
  const [warningIcons, setWarningIcons] = useState([]);
  const [notifications, setNotifications] = useState([]);
  var appSingleton = new AppSingleton();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  appSingleton.windowSize = windowSize;
  appSingleton.notifications = notifications;
  appSingleton.setNotifications = setNotifications;

  useEffect(() => {
    if (notifications.length > 0) {
      console.log("!!! new event detected");
      console.log(notifications);
      notifications.forEach((_notification) => {
        toast.info(_notification, {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      });
      setNotifications([]);
    }
  }, [notifications]);

  useEffect(() => {
    warningIcons.forEach((_icon) => {
      console.log(
        `https://www.hko.gov.hk/tc/wxinfo/dailywx/images/${hkoCodeToImageName(
          _icon
        )}.gif`
      );
    });
  }, [warningIcons]);

  useEffect(() => {
    const tryFetchWeather = async () => {
      const _weather = await WeatherData.weather;
      setIcons(_weather?.weatherReport?.icon);
      setWarningIcons(
        Object.values(_weather.warningSummary)
          .filter((el) => ["ISSUE", "EXTEND"].includes(el.actionCode))
          .map((el) => el.code)
      );
    };
    const scheduledTryFetchWeather = () => {
      console.log("tryFetchWeather");
      tryFetchWeather();
      setTimeout(() => {
        scheduledTryFetchWeather();
      }, 1000 * 60 * 1.1); // MARK: 1-min 6-sec
    };
    scheduledTryFetchWeather();

    // MARK: Windows Resize Listener
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (process.env.NODE_ENV === "debug") {
    console.log("!! DEBUG MODE");
  }

  return (
    <>
      <AppBar>
        {/* position="fixed"> */}
        <Toolbar
          disableGutters
          sx={{
            background: "#2E3B55",
            justifyContent: "space-between",
            display: "flex",
          }}
        >
          <IconButton
            onClick={() => {
              // navigate(-1);
              appSingleton?.navigate(-1);
              // const onAnimationCompleted = appSingleton?.leavePage()
            }}
          >
            <ArrowBackIosNew sx={{ color: "white" }} />
          </IconButton>
          <Box>
            <Typography
              variant="h6"
              color="inherit"
              component="div"
              noWrap
              sx={{ ml: 2, mr: 2 }}
              onClick={() => {
                appSingleton?.navigate("/");
              }}
            >
              老友記資訊
            </Typography>
          </Box>
          {/* <Box sx={{ flexGrow: 1 }}></Box> */}
          <Box justifyContent="flex-end" sx={{ pl: 2, pr: 2 }}>
            <Stack direction="row" spacing={2}>
              {warningIcons.map((_icon) => (
                <img
                  alt={_icon}
                  src={`https://www.hko.gov.hk/tc/wxinfo/dailywx/images/${hkoCodeToImageName(
                    _icon
                  )}.gif`}
                />
                // <Avatar
                //   alt={_icon}
                //   src={`https://www.hko.gov.hk/tc/wxinfo/dailywx/images/${hkoCodeToImageName(
                //     _icon
                //   )}.gif`}
                //   // src={`/static/images/hko_icons/${_icon.toLowerCase()}.gif`}
                // />
              ))}
              <IconButton
                onClick={(event) => setAnchorEl(event.currentTarget)}
                sx={{ p: 0 }}
              >
                <Avatar
                  alt="Weather"
                  src={
                    icons?.length > 0
                      ? `https://www.hko.gov.hk/images/HKOWxIconOutline/pic${icons[0]}.png`
                      : ""
                  }
                />
              </IconButton>
            </Stack>

            <Popover
              open={anchorEl != null}
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                style: { width: "50%" },
              }}
            >
              <WeatherInfo
                setIcons={setIcons}
                setWarningIcons={setWarningIcons}
              />
            </Popover>
          </Box>
        </Toolbar>
      </AppBar>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ContainerDrawer />
      </BrowserRouter>

      {/* <Typography gutterBottom variant="h6" component="div" sx={{ mt: 8 }}>
        *此網站內的資料只供個人非商業用途
      </Typography> */}

      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {/* <TopBar /> */}
        {/* <BrowserRouter>
          <AppDrawer sx={{ top: "flex", bottom: 0 }} />
        </BrowserRouter> */}
      </Box>
      <ToastContainer />
    </>
  );
};
export default App;
